module.exports = __webpack_public_path__ + "img/left_mask.0be4ab97.svg";